<template>
  <div id="about-form">
    <v-container>
    <v-flex xs12 sm8 md6>
    <p>{{ formTitle }}</p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-select
        :items="projectItems"
        v-model="projectSelected"
        label="Select Project"
        single-line
      ></v-select> 
      <v-select
        v-if="projectSelected"
        :items="projectDetailsItems"
        v-model="projectDetailsSelected"
        label="Select Project Detail"
        single-line
      ></v-select> 
      <input type="file" @change="onFileChange" id="file" name="file" multiple>
      <div v-if="imageFile">
        <img :src="imageFile" style="max-width:300px;max-height:300px;"/>
        <v-icon @click="removeImage">fa-times</v-icon>
      </div><br>
      <v-btn :disabled="!valid" @click="submit" color="primary">{{ buttonName }}</v-btn>
      <v-btn @click="clear" dark>Clear</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="goBack" dark>Back</v-btn>
    </v-form>
    </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '@/api'

export default {
  props: ['buttonName', 'editData', 'formTitle'],
  data () {
    return {
      projectSelected: null,
      projectDetailsSelected: null,
      id: null,
      valid: true,
      imageFile: '',
      projectItems: [],
      projectDetailsItems: []
    }
  },
  beforeMount () {
    this.getProjectsData()
  },
  computed: {
    ...mapGetters({
      currentUser: 'adminUser/getLoggedInUser'
    })
  },
  watch: {
    projectSelected: function () {
      this.projectDetailsItems = []
      if (this.projectSelected !== null) {
        this.getProjectDetails(this.projectSelected.id)
      }
    }
  },
  methods: {
    getProjectsData () {
      const path = '/project'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // this.projects = response.data.project
            response.data.project.forEach((el) => {
              this.projectItems.push({text: el.name, id: el.id})
            })
            // this.projectDetails = response.data.project_details
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    getProjectDetails (projectID) {
      const path = '/project/' + projectID
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            response.data.project_details.forEach((el) => {
              this.projectDetailsItems.push({text: el.headline, id: el.id})
            })
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    submit () {
      if (this.$refs.form.validate()) {
        const data = {
          id: this.id,
          project_id: this.projectSelected.id,
          project_details_id: this.projectDetailsSelected.id,
          current_user: this.currentUser
        }
        const imageInput = this.$el.querySelector('#file')
        this.$emit('addItem', data, imageInput)
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    goBack () {
      this.$emit('goBack')
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.imageFile = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage (e) {
      const imageInput = this.$el.querySelector('#file')
      imageInput.value = ''
      this.imageFile = ''
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MultipleImageInputForm.vue